import { spacing, styled } from "../../../stitches.config";

export const List = styled("ul", {
  listStyleType: "none",
  paddingLeft: "0",
  margin: "0",
});

export const ActivityDateGroup = styled("div", {
  gap: spacing.s,
});
